module.exports = "pegasus_template/assets/blocks/column-17-theme3.png";